import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { SampleAppUtilities } from "./utilities/SampleAppUtilities";
import { FaceTecStringsES, FaceTecStringsEN } from "./language/FaceTecStrings";
import { i18nInstance } from "../i18n";
import { sendLivenessMessage } from "../helpers/postMessageHelper";
import { createFlowProcessor } from "./processors/flowProcessorDispatcher";
import constants, { FLOW_MODE, KEY_LOCAL_STORAGE, KEY_LOCAL_STORAGE_GEO, } from "../constants";
export var SampleApp = (function () {
    var latestEnrollmentIdentifier = "";
    var latestSessionResult = null;
    var latestIDScanResult = null;
    var latestProcessor;
    var licenseText;
    var apiKey = "";
    var functionTrack = null;
    var onFaceTecReadyCallback = null;
    var currentFlowMode = FLOW_MODE.LIVENESS;
    var currentEnrollmentId = "";
    function getFlowSuccessMessage(mode) {
        if (mode === FLOW_MODE.ENROLLMENT) {
            return i18nInstance.t("facetec-enrollment-success");
        }
        if (mode === FLOW_MODE.AUTH_3D) {
            return i18nInstance.t("facetec-auth-success");
        }
        return i18nInstance.t("faceTec-success");
    }
    function onFaceTecReady(cb) {
        onFaceTecReadyCallback = cb;
    }
    function setExternalConfig(api, track) {
        apiKey = api;
        functionTrack = track;
    }
    if (typeof window !== "undefined") {
        window.onload = function () {
            licenseText = Config.license;
            // Initialize FaceTec Browser SDK and configure the UI features.
            FaceTecSDK.initializeInProductionMode(licenseText, Config.DeviceKeyIdentifier, Config.PublicFaceScanEncryptionKey, handleInitialize);
            SampleAppUtilities.disableAllButtons();
            // Set a the directory path for other FaceTec Browser SDK Resources.
            FaceTecSDK.setResourceDirectory("./core-sdk/FaceTecSDK.js/resources");
            // Set the directory path for required FaceTec Browser SDK images.
            FaceTecSDK.setImagesDirectory("./core-sdk/FaceTec_images");
            SampleAppUtilities.formatUIForDevice();
        };
    }
    function handleInitialize(initializedSuccessfully) {
        if (initializedSuccessfully) {
            if (i18nInstance.language == "es") {
                FaceTecSDK.configureLocalization(FaceTecStringsES);
            }
            else {
                FaceTecSDK.configureLocalization(FaceTecStringsEN);
            }
            SampleAppUtilities.themeCustomatizationMaat();
            if (onFaceTecReadyCallback)
                onFaceTecReadyCallback();
        }
        var message = i18nInstance.t("faceTec-initMessage");
        SampleAppUtilities.displayStatus(message);
        var num = FaceTecSDK.getStatus();
        if ([0, 3, 4, 8, 11].includes(num)) {
            console.log("error num " + num);
            setTimeout(function () {
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: "ConnectionError",
                    code: "".concat(num),
                });
            }, 2000);
        }
    }
    // Wait for onload to be complete before attempting to access the Browser SDK.
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        startFaceTecFlow(FLOW_MODE.LIVENESS);
    }
    function startFaceTecFlow(mode, enrollmentId) {
        if (enrollmentId === void 0) { enrollmentId = ""; }
        currentFlowMode = mode;
        currentEnrollmentId = enrollmentId;
        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the selected flow.
        getSessionToken(function (sessionToken) {
            latestProcessor = createFlowProcessor(sessionToken, SampleApp, currentFlowMode, currentEnrollmentId);
        });
    }
    function reportFlowConfigurationError(code, message) {
        sendLivenessMessage({
            cmd: "recognition-response",
            resultAction: "InvalidConfiguration",
            code: code,
        });
        SampleAppUtilities.displayStatus(message);
    }
    // Show the final result and transition back into the main interface.
    function onComplete(event) {
        var auditTrail = event.auditTrail, sessionId = event.sessionId;
        var image = auditTrail;
        SampleAppUtilities.showMainUI();
        if (!latestProcessor.isSuccess()) {
            // Reset the enrollment identifier.
            latestEnrollmentIdentifier = "";
            if (typeof window !== "undefined") {
                var message = i18nInstance.t("faceTec-warningMessage");
                // Show early exit message to screen.  If this occurs, please check logs.
                SampleAppUtilities.displayStatus(message);
            }
            if (functionTrack) {
                functionTrack(constants.UNSUCCESS, apiKey);
            }
            setTimeout(function () {
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: constants.UNSUCCESS,
                    header: FaceTecSDK.createFaceTecAPIUserAgentString(sessionId),
                    image: image,
                });
            }, 1000);
            return;
        }
        // Show successful message to screen
        if (typeof window !== "undefined") {
            var message = getFlowSuccessMessage(currentFlowMode);
            if (functionTrack) {
                functionTrack(constants.SUCCESS, apiKey);
            }
            setTimeout(function () {
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: constants.SUCCESS,
                    header: FaceTecSDK.createFaceTecAPIUserAgentString(sessionId),
                    image: image,
                    codeProcess: localStorage.getItem(KEY_LOCAL_STORAGE) || "",
                });
                localStorage.setItem(KEY_LOCAL_STORAGE_GEO, "");
            }, 1000);
            SampleAppUtilities.displayStatus(message);
        }
    }
    // Get the Session Token from the server
    function getSessionToken(sessionTokenCallback) {
        var options = "?op=session-token" +
            (Config.logoId != "" ? "&file_id=" + Config.logoId : "") +
            "&version=k_" + Config.FaceTecVersion;
        if (currentFlowMode !== FLOW_MODE.LIVENESS) {
            options += "&mode=" + currentFlowMode;
        }
        if (currentEnrollmentId) {
            options +=
                "&externalDatabaseRefID=" + encodeURIComponent(currentEnrollmentId);
        }
        var XHR = new XMLHttpRequest();
        XHR.open("GET", Config.BaseURL + options);
        XHR.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
        XHR.setRequestHeader("X-User-Agent", FaceTecSDK.createFaceTecAPIUserAgentString(""));
        XHR.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                var sessionToken = "";
                console.log("==> Response from server:", this.responseText);
                try {
                    // Attempt to get the sessionToken from the response object.
                    sessionToken = JSON.parse(this.responseText).sessionToken;
                    // Something went wrong in parsing the response. Return an error.
                    if (typeof sessionToken !== "string") {
                        console.log("==> Response from string:", this.responseText);
                        onServerSessionTokenError();
                        return;
                    }
                }
                catch (_a) {
                    console.log("==> Response from catch:", this.responseText);
                    // Something went wrong in parsing the response. Return an error.
                    onServerSessionTokenError();
                    return;
                }
                sessionTokenCallback(sessionToken);
            }
        };
        XHR.onerror = function () {
            console.log("==> Response from onerror:", this.responseText);
            onServerSessionTokenError();
        };
        XHR.send();
    }
    function onServerSessionTokenError() {
        SampleAppUtilities.handleErrorGettingServerSessionToken();
    }
    //
    // DEVELOPER NOTE:  This is a convenience function for demonstration purposes only so the Sample App can have access to the latest session results.
    // In your code, you may not even want or need to do this.
    //
    function setLatestSessionResult(sessionResult) {
        latestSessionResult = sessionResult;
    }
    function setIDScanResult(idScanResult) {
        latestIDScanResult = idScanResult;
    }
    function getLatestEnrollmentIdentifier() {
        return latestEnrollmentIdentifier;
    }
    function setLatestServerResult(responseJSON) { }
    function setLogoId(id) {
        return "".concat(Config.baseDomain, "/api/files/serve?id=").concat(id);
    }
    return {
        setExternalConfig: setExternalConfig,
        onLivenessCheckPressed: onLivenessCheckPressed,
        startFaceTecFlow: startFaceTecFlow,
        reportFlowConfigurationError: reportFlowConfigurationError,
        onComplete: onComplete,
        setLatestSessionResult: setLatestSessionResult,
        setIDScanResult: setIDScanResult,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        setLatestServerResult: setLatestServerResult,
        setLogoId: setLogoId,
        onFaceTecReady: onFaceTecReady,
    };
})();
